export default __webpack_public_path__ + "static/media/PEGI_3.2c0d8fac.svg";